"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PulseWidget = exports.mapStateToProps = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

require("./PulseWidget.scss");

var _TabList = require("@react/react-spectrum/TabList");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _PulseNotificationsTab = _interopRequireDefault(require("../tabs/PulseNotificationsTab"));

var _PulseAnnouncementsTab = _interopRequireDefault(require("../tabs/PulseAnnouncementsTab"));

var _StatusLight = _interopRequireDefault(require("./StatusLight"));

var _BulkNotificationUpdateService = _interopRequireDefault(require("../../service/BulkNotificationUpdateService"));

var _Toast = require("@react/react-spectrum/Toast");

var _NotificationReducer = require("../../store/reducers/NotificationReducer");

var _AnnouncementReducer = require("../../store/reducers/AnnouncementReducer");

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseWidget"));

var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));

var _SettingsLink = _interopRequireDefault(require("../commons/SettingsLink"));

var preferncesLocalizationString = _interopRequireWildcard(require("../viewall/__localization__/ViewAll"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: (0, _NotificationReducer.getLocale)(state),
    validLink: (0, _NotificationReducer.getNotificationLinkValidation)(state),
    activeTabIndex: (0, _NotificationReducer.getActiveTabIndex)(state),
    unreadCount: (0, _NotificationReducer.getUnreadNotificationCount)(state),
    isUnseenAnnouncements: (0, _AnnouncementReducer.hasUnseenAnnouncements)(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchToCloseInvalidLinkToast: function dispatchToCloseInvalidLinkToast() {
      dispatch({
        type: types.NOTIFICATION_URL_LINK_VALIDATION,
        payload: true
      });
    },
    dispatchToChangeActiveIndex: function dispatchToChangeActiveIndex(tabIndex) {
      dispatch({
        type: types.ACTIVE_TAB_INDEX_CHANGED,
        payload: tabIndex
      });
    },
    dispatchToMarkAllAsRead: function dispatchToMarkAllAsRead() {
      dispatch({
        type: types.MARK_ALL_NOTIFICATION_AS_READ
      });
    }
  };
};

var PulseWidgetHeader = function PulseWidgetHeader(props) {
  var activeTabIndex = props.activeTabIndex,
      onPreferencesClicked = props.onPreferencesClicked,
      locale = props.locale,
      handleTabChange = props.handleTabChange,
      hasUnseenAnnouncements = props.hasUnseenAnnouncements;
  return _react.default.createElement("div", {
    className: "pulse-widget-header"
  }, _react.default.createElement("div", {
    className: "pulse-widget-tabs"
  }, _react.default.createElement(_TabList.TabList, {
    onChange: handleTabChange,
    quiet: true,
    selectedIndex: activeTabIndex
  }, _react.default.createElement(_TabList.Tab, {
    className: "pulse-notification-tab"
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "Notifications",
    description: "Notification Title",
    messageId: "Notification"
  })), _react.default.createElement(_TabList.Tab, {
    className: "pulse-announcements-tab"
  }, _react.default.createElement("span", null, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "Announcements",
    description: "Announcements Title",
    messageId: "Announcements"
  })), _react.default.createElement(_StatusLight.default, {
    hasUnseenAnnouncements: hasUnseenAnnouncements
  }))), _react.default.createElement("div", {
    className: "pulse-widget-settings-container"
  }, _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: preferncesLocalizationString
  }, _react.default.createElement(_SettingsLink.default, {
    locale: locale,
    onPreferencesClicked: onPreferencesClicked,
    type: "flyout",
    variant: "action"
  })))));
};

var PulseWidget = function PulseWidget(props) {
  var locale = props.locale,
      validLink = props.validLink,
      activeTabIndex = props.activeTabIndex,
      unreadCount = props.unreadCount,
      isUnseenAnnouncements = props.isUnseenAnnouncements,
      dispatchToChangeActiveIndex = props.dispatchToChangeActiveIndex,
      dispatchToCloseInvalidLinkToast = props.dispatchToCloseInvalidLinkToast,
      dispatchToMarkAllAsRead = props.dispatchToMarkAllAsRead;
  var metrics = (0, _metrics.default)('exc.pulse.components.flyouts.PulseWidget');

  var handleTabChange = function handleTabChange(tabIndex) {
    if (tabIndex == 1) {
      metrics.event('flyout.announcementTab.clicked', {
        region: window.config && window.config.region
      });
    }

    if (activeTabIndex !== tabIndex) {
      dispatchToChangeActiveIndex(tabIndex);
    }
  };

  var markAllAsRead =
  /*#__PURE__*/
  function () {
    var _ref = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              metrics.event('flyout.markAllAsReadButton.click', {
                region: window.config && window.config.region
              });
              _context.next = 3;
              return _BulkNotificationUpdateService.default.markAllAsRead();

            case 3:
              result = _context.sent;

              if (result) {
                dispatchToMarkAllAsRead();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function markAllAsRead() {
      return _ref.apply(this, arguments);
    };
  }();

  var viewAllClicked = function viewAllClicked() {
    metrics.event('flyout.viewAllButton.click', {
      region: window.config && window.config.region
    });
    props.onViewAllClicked(activeTabIndex === 0 ? '' : 'announcements');
  };

  return _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localizationStrings
  }, _react.default.createElement("div", {
    className: "pulse-widget-root"
  }, !validLink && _react.default.createElement(_Toast.Toast, {
    className: "no-link-toast",
    closable: true,
    onClose: dispatchToCloseInvalidLinkToast
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "No link available for this notification",
    description: "No Link Notifaction Message",
    messageId: "NoLinkNotification"
  })), _react.default.createElement(PulseWidgetHeader, {
    activeTabIndex: activeTabIndex,
    handleTabChange: handleTabChange,
    hasUnseenAnnouncements: isUnseenAnnouncements,
    locale: locale,
    onPreferencesClicked: props.onPreferencesClicked
  }), _react.default.createElement("div", null, activeTabIndex === 0 ? _react.default.createElement(_PulseNotificationsTab.default, {
    locale: locale
  }) : _react.default.createElement(_PulseAnnouncementsTab.default, {
    locale: locale
  })), _react.default.createElement("div", {
    className: "pulse-widget-footer"
  }, activeTabIndex === 0 && _react.default.createElement(_Button.default, {
    className: "pulse-button-mark-all-as-read",
    disabled: unreadCount == 0,
    onClick: markAllAsRead,
    quiet: true,
    variant: "primary"
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "Mark all as read",
    description: "Mark all as read",
    messageId: "MarkAllAsRead"
  })), _react.default.createElement(_Button.default, {
    className: "pulse-button-view-all",
    onClick: viewAllClicked,
    quiet: true,
    variant: "primary"
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "View all",
    description: "View all",
    messageId: "ViewAll"
  })))));
};

exports.PulseWidget = PulseWidget;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PulseWidget);

exports.default = _default;